import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['toFocus']

  focus () {
    this.toFocusTarget.focus()
  }
}
